module.exports = __webpack_public_path__ + "static/media/features-tabs-icon-02.59e2091d.svg";